<template>
	<div class="tcp-page tcp-collections">
		<section class="tcp-collections__hero">
			<div class="tcp-collections__wrap">
				<p class="tcp-kicker">Curated Collections</p>
				<h1>Intentionally<br><span>curated for you...</span></h1>
				<p>Each collection tells a story. Thoughtfully assembled bundles and lifestyle selections designed to support your unique wellness journey.</p>
			</div>
		</section>

		<section class="tcp-collections__grid-wrap">
			<div class="tcp-collections__wrap tcp-collections__grid">
				<article class="tcp-coll tcp-coll--feature">
					<img :src="items[0].image" :alt="items[0].title">
					<span class="tcp-coll__tag tcp-coll__tag--solid">{{ items[0].tag }}</span>
					<div class="tcp-coll__copy">
						<p class="tcp-coll__sub">{{ items[0].subtitle }}</p>
						<h2>{{ items[0].title }}</h2>
						<p>{{ items[0].description }}</p>
						<router-link to="/shop" class="tcp-coll__btn">Explore Collection <i class="fa fa-arrow-right"></i></router-link>
					</div>
				</article>

				<article class="tcp-coll tcp-coll--side">
					<img :src="items[1].image" :alt="items[1].title">
					<div class="tcp-coll__copy">
						<span class="tcp-coll__tag">{{ items[1].tag }}</span>
						<h3>{{ items[1].title }}</h3>
						<p class="tcp-coll__sub">{{ items[1].subtitle }}</p>
					</div>
				</article>

				<article class="tcp-coll tcp-coll--side">
					<img :src="items[2].image" :alt="items[2].title">
					<div class="tcp-coll__copy">
						<span class="tcp-coll__tag">{{ items[2].tag }}</span>
						<h3>{{ items[2].title }}</h3>
						<p class="tcp-coll__sub">{{ items[2].subtitle }}</p>
					</div>
				</article>

				<article class="tcp-coll tcp-coll--half">
					<img :src="items[3].image" :alt="items[3].title">
					<div class="tcp-coll__copy">
						<span class="tcp-coll__tag">{{ items[3].tag }}</span>
						<h3>{{ items[3].title }}</h3>
						<p class="tcp-coll__sub">{{ items[3].subtitle }}</p>
						<p class="tcp-coll__desc">{{ items[3].description }}</p>
					</div>
				</article>

				<article class="tcp-coll tcp-coll--half">
					<img :src="items[4].image" :alt="items[4].title">
					<div class="tcp-coll__copy">
						<span class="tcp-coll__tag">{{ items[4].tag }}</span>
						<h3>{{ items[4].title }}</h3>
						<p class="tcp-coll__sub">{{ items[4].subtitle }}</p>
						<p class="tcp-coll__desc">{{ items[4].description }}</p>
					</div>
				</article>

				<article class="tcp-coll tcp-coll--wide">
					<img :src="items[5].image" :alt="items[5].title">
					<div class="tcp-coll__copy tcp-coll__copy--left">
						<span class="tcp-coll__tag tcp-coll__tag--solid">{{ items[5].tag }}</span>
						<p class="tcp-coll__sub">{{ items[5].subtitle }}</p>
						<h2>{{ items[5].title }}</h2>
						<p class="tcp-coll__desc">{{ items[5].description }}</p>
						<router-link to="/shop" class="tcp-coll__btn">Explore Collection <i class="fa fa-arrow-right"></i></router-link>
					</div>
				</article>
			</div>
		</section>

		<section class="tcp-collections__cta">
			<h2>Not sure where to start?</h2>
			<p>Take our wellness quiz to discover which collection is perfectly aligned with your goals and lifestyle.</p>
			<button type="button" class="tcp-btn tcp-btn--outline">Take the Quiz <i class="fa fa-arrow-right"></i></button>
		</section>
	</div>
</template>

<script>
function asset(file) {
	return tools.url('/public/images/collections/' + file)
}

export default {
	data() {
		return {
			items: [
				{
					title: "The Founder's Favorites",
					subtitle: 'Handpicked essentials',
					description: "Our founder's personal selection of daily supplements that transformed her wellness journey. Each product represents years of research and real results.",
					image: asset('collection-founders-favorites.jpg'),
					tag: "Editor's Pick"
				},
				{
					title: 'The Mindful Morning',
					subtitle: 'Start your day intentionally',
					description: 'A curated collection designed to kickstart your morning with clarity, energy, and purpose. The perfect ritual for those who value conscious living.',
					image: asset('collection-mindful-morning.jpg'),
					tag: 'Lifestyle'
				},
				{
					title: '30-Day Wellness Reset',
					subtitle: 'Complete transformation bundle',
					description: "Everything you need for a month-long wellness reset. Carefully selected supplements that work synergistically to support your body's natural balance.",
					image: asset('collection-wellness-reset.jpg'),
					tag: 'Bundle'
				},
				{
					title: "The Athlete's Stack",
					subtitle: 'Performance meets recovery',
					description: 'Specially curated for active lifestyles. Support your training, optimize recovery, and fuel your performance.',
					image: asset('collection-athlete-stack.jpg'),
					tag: 'Performance'
				},
				{
					title: 'Winter Wellness',
					subtitle: 'Seasonal immunity support',
					description: 'Fortify your defenses during colder months. A seasonal collection focused on immune health, energy, and resilience.',
					image: asset('collection-winter-wellness.jpg'),
					tag: 'Seasonal'
				},
				{
					title: 'The Busy Professional',
					subtitle: 'Thrive under pressure',
					description: 'Designed for demanding schedules. Maintain focus, manage stress, and sustain energy throughout your busiest days.',
					image: asset('collection-busy-professional.jpg'),
					tag: 'Lifestyle'
				}
			]
		}
	}
}
</script>
